//@ts-ignore
import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

import { MapPin } from "../../components/Map";
import { MapContext } from "../../context/map.context";

// Component to display users location on an immovable map
const LatLongDisplay = () => {

  const { setPins, flyTo, setUserLocation, map} = useContext(MapContext);
  const { latitude, longitude, accuracy} = useParams();

  // Add user's location pin -> Array as future dev could be to plot multiple points
  useEffect(() => {
    const pinsToPlot: MapPin[] = [];
    if (latitude && longitude && accuracy) {
      setUserLocation({lat: parseFloat(latitude), lng: parseFloat(longitude), accuracy: parseFloat(accuracy)})

      const userPin: MapPin = {
        lng: parseFloat(longitude),
        lat: parseFloat(latitude),
        size: 0,

      };
      pinsToPlot.push(userPin);

      // Fly to user's location on load
      flyTo({
        center: { lng: parseFloat(longitude), lat: parseFloat(latitude) },
        zoom: 20,
      });

      // Set pins on the map
      if (pinsToPlot.length > 0) {
        setPins(pinsToPlot);
      }

      // Disable ability to move map
      if (map) {
        map.boxZoom.disable();
        map.scrollZoom.disable();
        map.dragPan.disable();
        map.dragRotate.disable();
        map.doubleClickZoom.disable();
        map.touchZoomRotate.disable();
      }
    }
  }, [latitude, longitude, flyTo, setPins, accuracy, setUserLocation, map]);

  return null;
};

export default LatLongDisplay;
